import {
  ABIActionDrawer,
  ABIIconButton,
  DrawerContainerPosition,
  OpenInNewIcon
} from '@ab-inbev-labs/ux-react-components';
import { useTranslation } from 'react-i18next';
import './UserProfile.scss';
import { reportIssueLink, submitEnhancementLink, userGuideLink } from './constants';
import { FC } from 'react';
import { HelpMenuButtonData } from './userProfileSettings/types';
import { LayoutTestIds } from '@ab-inbev/sam-utils';

type HelpMenuProps = {
  additionalHelpMenuContent?: HelpMenuButtonData[];
};

export const HelpMenu: FC<HelpMenuProps> = ({ additionalHelpMenuContent }) => {
  const { t } = useTranslation();

  const createHelpMenuButton = (text: string, link: string) => {
    return (
      <ABIIconButton onClick={() => window.open(link, '_blank')} data-testid={LayoutTestIds.HelpMenuButton}>
        {t(text)}
        {<OpenInNewIcon color="var(--color-contrast-focused)" height={18} width={18} />}
      </ABIIconButton>
    );
  };

  return (
    <ABIActionDrawer
      drawerContainerPosition={DrawerContainerPosition.BottomRight}
      closeOnContainerClick
      className="general-help-drawer"
      drawerClassName="general-help-action-drawer"
      buttonContent={<div className="general-help">{t('common.actions.help')}</div>}
    >
      <div className="profile-help-wrap">
        {createHelpMenuButton('helpLinks.reportAnIssue', reportIssueLink)}
        {createHelpMenuButton('helpLinks.enhancementReq', submitEnhancementLink)}
        {createHelpMenuButton('helpLinks.userGuides', userGuideLink)}
        {additionalHelpMenuContent?.map((item) => createHelpMenuButton(item.text, item.link))}
      </div>
    </ABIActionDrawer>
  );
};
